import React from 'react';
import { Route, Routes } from 'react-router-dom';
import * as Pages from './pages/index';
import { ROUTE_PREFIX } from 'configs/constants';
import * as Sentry from '@sentry/react';

export default function RouteManager() {
  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

  return (
    <SentryRoutes>
      <Route path={`${ROUTE_PREFIX}/receipt/:receiptid`} element={<Pages.Main />} />
      <Route path={`${ROUTE_PREFIX}/receipt`} element={<Pages.Receipt />} />
    </SentryRoutes>
  );
}
